import { Box, BoxProps } from "@chakra-ui/react";
import { colors } from "theme";
export interface TextStrokeProps extends BoxProps {
  title: string;
  containerProps?: BoxProps;
  textProps?: BoxProps;
}

export default function TextStroke({
  title,
  containerProps,
  textProps,
  ...rest
}: TextStrokeProps) {
  return (
    <Box
      as="svg"
      xmlns="http://www.w3.org/2000/svg"
      width={400}
      height={155}
      viewBox="0 0 400 101"
      {...containerProps}
    >
      <Box
        as="text"
        fillOpacity="0"
        fillRule="evenodd"
        stroke={colors.mainTextStroke}
        strokeWidth=".6"
        fontSize="130px"
        fontWeight="bold"
        transform="translate(-994px, -151px)"
        {...rest}
      >
        <Box
          as={"tspan"}
          x="990px"
          y="250px"
          fontFamily="sans-serif"
          {...textProps}
        >
          {title}
        </Box>
      </Box>
    </Box>
  );
}
